export enum ImportTypes {
  IMPORT = "IMPORT",
  PREVIEW = "PREVIEW",
}